<template>
    <section class="assessmentSection protectionLevelOverview aocIntroSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">70% complete</div>
            <div class="pageTitle">First, what is an area of concern?</div>
            <div class="pageText">
                <p>
                    An area of concern is a room in your home that is vulnerable to intrusion, typically through a window. Every home is unique, which means everyones areas of concern could be different.
                </p>
            </div>
            <div class="interactiveImageSection">
                <img src="/img/aoc-no-intruder.png"
                     class="interactiveImage"
                     alt="" />
                <!-- Tag: Living Room -->
                <div class="tag livingRoom">
                    <div class="tagLabel" ref="labelLivingRoom">Living room</div>
                    <div class="tagIcon" ref="iconLivingRoom"> <img src="/img/yield.png" /> </div>
                </div>
                <!-- Tag: Basement -->
                <div class="tag basement">
                    <div class="tagLabel" ref="labelBasement">Basement</div>
                    <div class="tagIcon" ref="iconBasement"> <img src="/img/yield.png" /> </div>
                </div>
                <!-- Tag: Master Bedroom -->
                <div class="tag bedroom">
                    <div class="tagIcon" ref="iconBedroom"> <img src="/img/yield.png" /> </div>
                    <div class="tagLabel" ref="labelBedroom">Master Bedroom</div>
                </div>
                <!-- Tag: Master Kitchen -->
                <div class="tag kitchen">
                    <div class="tagIcon" ref="iconKitchen"> <img src="/img/yield.png" /> </div>
                    <div class="tagLabel" ref="labelKitchen">Kitchen</div>
                </div>
            </div>
            <continue-button to="/assessment/accessibility"
                             text="Next" />
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([]),
        popIn(ref, delay) {
            let duration = 500
            let timeout = duration + delay
            setTimeout(() => { this.$refs[ref].className += ' animated' }, delay)
        }
    },
    mounted() {
        let that = this
        that.popIn('iconLivingRoom', 1000)
        that.popIn('iconBasement', 1250)
        that.popIn('iconBedroom', 1500)
        that.popIn('iconKitchen', 1850)
        that.popIn('labelLivingRoom', 2500)
        that.popIn('labelBasement', 2600)
        that.popIn('labelBedroom', 2700)
        that.popIn('labelKitchen', 2800)
    }
}
</script>

<style lang="css"></style>
